var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-breadcrumb',{staticClass:"common-breadcrumb",attrs:{"separator":"/"}},_vm._l((_vm.breadList),function(item,index){return _c('el-breadcrumb-item',{key:index},[_vm._v(_vm._s(item))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }